import type { ScalarConfig } from '@/schema'
import type { ConfigFileGetter } from '@/types'
import { defaultTheme, type Theme } from '@scalar-org/entities/theme'

/**
 * Gets all theme data from the config file and injects it into the theme object
 *
 * Will return a default theme object as the base if not other theme is specified
 */
export async function resolveTheme({
  config,
  theme: _theme,
  fileGetter,
}: {
  config: ScalarConfig
  theme?: Theme
  fileGetter: ConfigFileGetter<any>
  parallel?: boolean
}) {
  const theme = {
    ...defaultTheme(),
    ..._theme,
  }

  // Extend the theme with any custom CSS files
  // We will resolve synchronously to allow a specific order of injection
  for (const path of config.siteConfig.cssFiles ?? []) {
    theme.theme += `\n${await fileGetter({ path })}`
  }

  if (config.siteConfig?.cssString) {
    theme.theme += `\n${config.siteConfig.cssString}`
  }

  return theme
}
